'use strict';

import scrollMonitor from 'scrollmonitor';

class PageNav {
  constructor (config) {
    const self = this;
    self.el = config.el;

    self.nav = self.el.querySelector('[data-page-nav]');
    self.links = self.nav.querySelectorAll('a');
    self.sections = self.el.querySelectorAll('[data-page-section]');

    self.setupNavWatcher();
    // self.setupSectionWatchers();
  }

  setupNavWatcher () {
    const self = this;

    let navWatcher = scrollMonitor.create(self.nav);
    navWatcher.lock();

    if ( navWatcher.isAboveViewport ) {
      self.nav.classList.add('-fixed');
    }

    navWatcher.stateChange(function() {
      if ( this.isAboveViewport ) {
        self.nav.classList.add('-fixed');
      } else {
        self.nav.classList.remove('-fixed');
      }
    });
  }

  // setupSectionWatchers () {
  //   const self = this;
  //   [].forEach.call(self.sections, section => {
  //     let watcher = scrollMonitor.create(section);
  //     watcher.lock();
  //     watcher.stateChange(function() {
  //       let link = self.nav.querySelector('[href="#' + section.getAttribute('id') + '"]');
  //       if ( this.isAboveViewport ) {
  //         self.deactivateAllLinks();
  //         link.classList.add('-active');
  //       } else {
  //         link.classList.remove('-active');
  //       }
  //     });
  //   });
  // }
  //
  // deactivateAllLinks () {
  //   const self = this;
  //   [].forEach.call(self.links, link => {
  //     link.classList.remove('-active');
  //   });
  // }
}

const pageNav = document.querySelector('.js-page-nav');
if (!!pageNav) {
  new PageNav({el: pageNav});
}



// WEBPACK FOOTER //
// ./app/javascript/modules/page-nav.js